<template>
  <div class="nps-scale">
    <div class="relative" :style="scaleStyle">
      <ul class="flex justify-between">
        <li
          class="scale-item"
          v-for="(item, index) in issue.labels"
          :key="item.id"
          :style="issue.getActiveColor(issue.value, index)"
          @click="onChange(item)"
        >
          <div>
            <span>{{ item.num }}</span>
          </div>
        </li>
      </ul>
      <div class="text-small clearfix mt-2 text-theme-black-450">
        <span class="float-left">
          <span>{{ issue.firstLabel.text }}</span>
        </span>
        <span class="float-right">
          <span>{{ issue.lastLabel.text }}</span>
        </span>
      </div>
    </div>
    <div class="unknown-box" key="unknown" v-if="issue.show_unknown">
      <el-radio v-model="issue.value" label="unknown">
        <span>{{ issue.unknown_text }}</span>
      </el-radio>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NPSScale',
  changeExpr: 'issue.value',
  computed: {
    scaleStyle() {
      return {
        width: Math.min(this.issue.labels.length * 90, 690) + 'px'
      }
    }
  },
  methods: {
    onChange(item){
      if(this.view) return
      this.issue.value = item.id
    }
  }
}
</script>
